'use es6';

import tinymce from 'tinymce';
import { SpacingIconTypes } from 'rich-text-lib/constants/spacing';
import { i18nWithNameSpace } from '../utils/i18n';
import EmbedPopoverManager from '../components/EmbedPopoverManager';
import { hsmediaConfig } from '../constants/hsMedia';
import { getRemoveEmbedHandler, getEmbedSaveHandler, isEditableEmbed, getEmbedOptions } from '../utils/embed';
import { CANVAS_EMBED } from '../constants/toolbar';
import { getEmbedContextualToolbar } from '../constants/contextualToolbar';
import { getEmbedClickHandler } from './handlers';
import { getEmbedPluginSetting } from './util';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = i18nWithNameSpace('TinymcePlugins.hsmedia');
export function addControls(editor, pluginName, openEmbedModal) {
  const embedClickHandler = getEmbedClickHandler(editor, openEmbedModal);
  tinymce.canvas.addMenuItem(editor, CANVAS_EMBED, {
    text: i18nKey('menuItem'),
    onClick: embedClickHandler
  });
  const showAlignmentControls = !getEmbedPluginSetting(editor, hsmediaConfig.DISABLE_ALIGNMENT);
  const showMarginControls = !getEmbedPluginSetting(editor, hsmediaConfig.DISABLE_SPACING);
  const isActiveNodeHandler = ({
    element
  }) => {
    if (!element) return false;
    return isEditableEmbed(editor, element) && element;
  };
  const getActiveNodeAttributes = node => {
    return Object.assign({}, getEmbedOptions(editor, node), {
      justifyDisabledTooltip: i18nKey('fullWidthDisabledTooltip'),
      dimensionsDisabledTooltip: i18nKey('dimensionsDisabledTooltip'),
      marginIconType: SpacingIconTypes.EMBED,
      useFullWidth: true
    });
  };
  tinymce.canvas.addNodeChangeHandler(editor, {
    eventKey: pluginName,
    isActiveNodeHandler,
    getActiveNodeAttributes,
    contextualToolbar: getEmbedContextualToolbar({
      showAlignmentControls,
      showMarginControls
    })
  });
  tinymce.canvas.addPopover(editor, pluginName, {
    renderPopover(renderProps) {
      return /*#__PURE__*/_jsx(EmbedPopoverManager, Object.assign({
        editor: editor,
        onEmbedRemove: getRemoveEmbedHandler(editor),
        onEmbedSave: getEmbedSaveHandler(editor),
        eventKey: pluginName
      }, renderProps));
    }
  });
}